import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-stock-count-modal',
  templateUrl: './stock-count-modal.component.html',
  styleUrls: ['./stock-count-modal.component.scss'],
})
export class StockCountModalComponent {
  name = '';
  number = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data, private dialogRef: MatDialogRef<StockCountModalComponent>) {
    this.name = data.firstName;
    this.number = data.stockCountNo;
  }

  gotoOverviewAndClose() {
    this.dialogRef.close({ goToOverview: true });
  }

  gotoDetailAndClose() {
    this.dialogRef.close({ goToDetail: true, number: this.data.number });
  }

  gotoCreateAndClose() {
    this.dialogRef.close({ goToCreate: true });
  }
}
